import { render } from "./NFTs.vue?vue&type=template&id=6a645978&scoped=true"
import script from "./NFTs.vue?vue&type=script&lang=js"
export * from "./NFTs.vue?vue&type=script&lang=js"

import "./NFTs.vue?vue&type=style&index=0&id=6a645978&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6a645978"

export default script